import { render, staticRenderFns } from "./WallPostsSkeleton.vue?vue&type=template&id=64e22e8c&scoped=true"
import script from "./WallPostsSkeleton.vue?vue&type=script&lang=js"
export * from "./WallPostsSkeleton.vue?vue&type=script&lang=js"
import style0 from "./WallPostsSkeleton.vue?vue&type=style&index=0&id=64e22e8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e22e8c",
  null
  
)

export default component.exports